// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2fi_J","buttons":"Footer_buttons__3uHPV"};